// extracted by mini-css-extract-plugin
export var active = "_jq-2";
export var recordingDot = "_jq-1";
export var recordingIndicator = "_jq-0";